import {create} from 'zustand';
import {JobDetailDto, PartItemDetailDto} from '../api/generated/index.defs';
import {JobsService} from '../api/generated/JobsService';

type JobStoreVariables = {
  job: JobDetailDto | null;
  isJobLoading: boolean;
  replacedPartItems: PartItemDetailDto[] | null;
  isLoadingReplacedParts: boolean;
  isJobReadonly: boolean;
};

type JobStoreFunctions = {
  fetchJob: (jobId: number) => Promise<void>;
  fetchReplacedParts: (jobId: number) => Promise<void>;
  clearJob: () => void;
  clearReplacedParts: () => void;
};

type JobStore = JobStoreVariables & JobStoreFunctions;

const DEFAULT_VALUE: JobStoreVariables = {
  job: null,
  isJobLoading: false,
  replacedPartItems: null,
  isLoadingReplacedParts: false,
  isJobReadonly: false,
};

export const useJobStore = create<JobStore>((set) => ({
  ...DEFAULT_VALUE,
  clearJob: () => set({job: null}),
  clearReplacedParts: () => set({replacedPartItems: null}),
  fetchJob: async (id: number) => {
    set({isJobLoading: true});
    const {data} = await JobsService.getById({id});
    // eslint-disable-next-line no-restricted-syntax
    console.log("data: ", data);
    set({
      job: data,
      isJobLoading: false,
      isJobReadonly: data?.status === 'Closed - Archived',
    });
  },
  fetchReplacedParts: async (jobId: number) => {
    set({isLoadingReplacedParts: true});
    const {data} = await JobsService.getPartItemsWithRequiredLotNumberByJobId({
      jobId,
    });
    set({replacedPartItems: data, isLoadingReplacedParts: false});
  },
}));